import { render } from "./ProjectAtlas.vue?vue&type=template&id=60a8145b&scoped=true&lang=html"
import script from "./ProjectAtlas.vue?vue&type=script&lang=js"
export * from "./ProjectAtlas.vue?vue&type=script&lang=js"

import "./ProjectAtlas.vue?vue&type=style&index=0&id=60a8145b&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a8145b"]])

export default __exports__